// extracted by mini-css-extract-plugin
module.exports = {"selectedSolutions":"styles_selectedSolutions__1LQUm","selectedSolutions_map":"styles_selectedSolutions_map__3N5hM"};